<template>
    <b-row class="mb-1">
        <b-col
            sm="12"
            :md="md"
            :lg="lg"
            :xl="xl"
            :class="{
                'pr-1': $mq != 'sm' && $mq != 'md',
                'text-right': $mq != 'sm' && $mq != 'md'
            }"
            >{{ titulo }}</b-col
        >
        <b-col
            sm="12"
            :md="mddiff"
            :lg="lgdiff"
            :xl="xldiff"
            :class="{ 'pl-1': $mq != 'sm' && $mq != 'md' }"
        >
            <span v-if="dado">
                <strong v-if="tipo == null">{{ dado }}</strong>
                <strong v-if="tipo == 'datetime'">{{
                    $moment(dado).format('DD/MM/YYYY HH:mm')
                }}</strong>
                <strong v-if="tipo == 'date'">{{
                    $moment(dado).format('DD/MM/YYYY')
                }}</strong>
            </span>
            <slot v-if="!dado"></slot>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'DetalheComponent',
    props: {
        titulo: {
            type: String,
            default: ''
        },

        dado: {
            default: null
        },

        tipo: {
            type: String,
            default: null
        },

        md: {
            type: Number,
            default: 4
        },

        lg: {
            type: Number,
            default: 4
        },

        xl: {
            type: Number,
            default: 2
        }
    },

    methods: {},

    computed: {
        mddiff() {
            return 12 - this.md
        },

        lgdiff() {
            return 12 - this.lg
        },

        xldiff() {
            return 12 - this.xl
        }
    }
}
</script>
